module.exports = __webpack_public_path__ + "static/img/nic.90df73a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/nic.svg
// module id = v/VT
// module chunks = 0